import React, { Fragment } from "react";

interface BottomDots {
  dots: string[];
}

function BottomDots({ dots = [] }: BottomDots) {
  if (dots.length === 0) {
    return <div className="calendar-state-wrap"></div>;
  }

  return (
    <div className="calendar-state-wrap">
      {dots.sort().map((classStateType: string, i: number) => {
        return (
          <Fragment key={i}>
            {classStateType === "CLASS" && <span className="calendar-state orange"></span>}
            {classStateType === "AP" && <span className="calendar-state puple"></span>}
            {classStateType === "ET" && <span className="calendar-state gray"></span>}
          </Fragment>
        );
      })}
    </div>
  );
}

export default BottomDots;
